import { getCloseTimeout } from '../selectors/close-timeout';
export const setCloseTimeout = (timeout) => (dispatch, getState) => {
    const closeTimeout = getCloseTimeout(getState());
    if (closeTimeout)
        clearTimeout(closeTimeout);
    dispatch({ type: 'TROUBLESHOOTING/SET_CLOSE_TIMEOUT', payload: timeout });
};
